export default "__VITE_ASSET__1f6b8144__"